<template>
  <div class="main">
    <div class="container">

      <el-collapse-transition>
        <div v-if="!isShowRegister">
          <login-form @isShowRegister="isShowRegister = true" v-if="!isShowRegister"></login-form>
        </div>
      </el-collapse-transition>

      <el-collapse-transition>
        <div v-if="isShowRegister">
          <register-from @isShowRegister="isShowRegister = false"></register-from>
        </div>
      </el-collapse-transition>
    </div>

    <div class="cpu">
      <a href="https://www.sxbicsp.com/admin/login" target="_blank" class="flex flex_align-items">
        <img src="../../assets/logo.png" alt="">
        <span>知识库</span>
      </a>
    </div>
  </div>
</template>

<script>
import LoginForm from './components/login-from.vue'
import RegisterFrom from './components/register-from.vue'

export default {
  name: 'LoginView',
  components: {
    LoginForm,
    RegisterFrom
  },
  data() {
    return {
      isShowRegister: false
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

.main {
  background: url(../../assets/logo-bg.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: fixed;
  min-width: 1240px;

  .container {
    position: absolute;
    top: 50%;
    right: 20%;
    width: 20%;


  }
}

.cpu {
  position: absolute;
  top: 5%;
  right: 5%;
  z-index: 9;

  a {
    color: #999999;
    text-align: center;
    font-size: 20px;

    img {
      width: 80px;
      margin-right: 10px;
    }
  }
}
</style>
